<template>
  <div class="sample texture-bg-css">
    <Top></Top>
    <Storehouse></Storehouse>
  </div>
</template>

<script>
import Top from '@/components/sample/Top'
import Storehouse from '@/components/sample/Storehouse'

export default {
  name: 'sample',
  components: {
    Top,
    Storehouse
  },
  mixins: [],
  data() {
    return {}
  },
  mounted: function() {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
